/**
 * HomeCTA — neutral informational closing block.
 * Email contact only, behind an explicit click-to-reveal action.
 */

import { memo } from "react";
import { useTranslation } from "react-i18next";
import Reveal from "@/components/common/Reveal";
import EmailReveal from "@/components/common/EmailReveal";

const HomeCTA = () => {
  const { t } = useTranslation();

  return (
    <section
      id="contact"
      className="bg-ink-deep text-white py-20 md:py-28 scroll-mt-20"
      aria-labelledby="home-cta-heading"
    >
      <div className="container mx-auto px-6">
        <Reveal>
          <div className="flex items-center gap-4 mb-6">
            <span className="rule-light w-10 shrink-0" aria-hidden="true" />
            <p className="eyebrow text-cobalt-bright">{t("home.cta.label")}</p>
          </div>
          <h2 id="home-cta-heading" className="display-xl text-white max-w-5xl">
            {t("home.cta.heading")}
          </h2>
          <p className="mt-6 max-w-2xl text-base md:text-lg text-white/75">
            {t("home.cta.body")}
          </p>
        </Reveal>

        <Reveal delay={90}>
          <div className="mt-12 md:mt-16 border-t border-white/20 pt-8">
            <p className="eyebrow text-white/55 mb-4">{t("home.cta.emailLabel")}</p>
            <EmailReveal tone="light" size="lg" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default memo(HomeCTA);
